import * as React from 'react'

import { useInternalTransfer } from './hooks'
import { CButton, CCol, CRow } from '@coreui/react-pro'
import { path, role } from '../../../../libs'
import { $userRole } from '../../../../features/user'
import { useStore } from 'effector-react'

export const InternalTransferDetail = () => {
  const internalTransfer = useInternalTransfer()
  const userRole = useStore($userRole)
  return (
    <div>
      <CRow>
        <CCol>
          <CButton
            hidden={
              Array.isArray(userRole) &&
              [
                role.partnership.seniorPartnerManager(),
                role.partnership.juniorPartnerManager(),
              ].some((r) => userRole.includes(r))
            }
            color="primary"
            className="me-2"
            title={'Edit'}
            href={path.billing.internalTransfer.entry()}
          >
            Edit
          </CButton>
          <div className="mt-2">
            <span className="text-muted">isAuto:</span>{' '}
            {internalTransfer.isAuto}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingProvider:</span>{' '}
            {internalTransfer.processingProvider}
          </div>
          <div className="mt-2">
            <span className="text-muted">processingMethod:</span>{' '}
            {internalTransfer.processingMethod}
          </div>
          <div className="mt-2">
            <span className="text-muted">status:</span>{' '}
            {internalTransfer.status}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialAmount:</span>{' '}
            {internalTransfer.initialAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">initialCurrency:</span>{' '}
            {internalTransfer.initialCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientAmount:</span>{' '}
            {internalTransfer.clientAmount}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCurrency:</span>{' '}
            {internalTransfer.clientCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">clientCommission:</span>{' '}
            {internalTransfer.clientCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">companyCommission:</span>{' '}
            {internalTransfer.companyCommission}
          </div>
          <div className="mt-2">
            <span className="text-muted">commissionCurrency:</span>{' '}
            {internalTransfer.commissionCurrency}
          </div>
          <div className="mt-2">
            <span className="text-muted">createdAt:</span>{' '}
            {internalTransfer.createdAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">updatedAt:</span>{' '}
            {internalTransfer.updatedAt}
          </div>
          <div className="mt-2">
            <span className="text-muted">Client:</span>
            {internalTransfer.client.clientId}{' '}
            {internalTransfer.client.fullName}
            {internalTransfer.client.email} {internalTransfer.client.partner}
          </div>
          <div className="mt-2">
            <span className="text-muted">Manager:</span>
            {internalTransfer.client.clientId}{' '}
            {internalTransfer?.manager?.userId}
          </div>
        </CCol>
      </CRow>
    </div>
  )
}
